import { Card, CardContent, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { Booth } from '../../../../../../../../interfaces/interfaces';
import { numberWithThousandPoint } from '../../../../../../../../services/helper';
import { getMeetingMinutes } from '../../../../../../../../services/services';

export const BoothMeetingMinutes = ({ booth }: { booth: Booth }) => {
  const [boothMeetingMinutes, setBoothMeetingMinutes] = useState<{ count: number; meetingtype: string }[]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { t } = useTranslation('');

  useEffect(() => {
    fetchData();
  }, [booth]);

  async function fetchData() {
    try {
      const boothMeetingMinutesCount = await getMeetingMinutes(booth._id);
      setBoothMeetingMinutes(boothMeetingMinutesCount);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  }
  return (
    <>
      <Card className="w-full mt-8" elevation={3}>
        {isLoading && (
          <div className="text-center m-4">
            <Skeleton animation="wave" height={30} width="60%" style={{ marginBottom: 6 }} />
            <Skeleton animation="wave" height={30} width="20%" style={{ marginBottom: 6 }} />
          </div>
        )}
        {!isLoading && (
          <CardContent>
            <Typography className="font-size: 1rem;line-height: 1.5rem;" color="textSecondary" gutterBottom>
              {t('stats:booth-stats-meeting-minutes')}
            </Typography>
            {boothMeetingMinutes
              ?.sort((a, b) => b.count - a.count)
              .map((meeting) => (
                <>
                  <Typography className="font-size: 1rem;line-height: 1rem;" color="textSecondary" gutterBottom>
                    {t(`account:meeting-types.${meeting.meetingtype}`)}
                  </Typography>
                  <Typography variant="h5" component="h2">
                    {boothMeetingMinutes !== undefined ? numberWithThousandPoint(Math.floor(meeting.count / 60000)) : 0}
                  </Typography>
                </>
              ))}
          </CardContent>
        )}
      </Card>
    </>
  );
};
